import React from "react";
import { BUTTON_ACTIVATION_KEYS } from "src/common/constants";

/**
 * Props that make a non-button element behave like a button for keyboard users: focusable, announced as
 * a button, and activated by Enter or Space.
 *
 * The wizard's expand affordances have to be divs — they wrap rows of content rather than a label — and
 * without these a keyboard-only operator can reach every Button but can't open an action's principal
 * list, the "Not eligible" list, a result row, or the skipped group. The registration codes live behind
 * a result-row expand, so this isn't only cosmetic.
 *
 * Note: principal-summary-card has an older variant of this keyed on the Control key. Enter and Space
 * are what role="button" promises a screen reader, so this uses those rather than copying it.
 *
 * @param expanded whether the controlled content is currently open. Emitted as aria-expanded: sighted
 *                 operators read the caret, and this is the equivalent for everyone else.
 * @param toggle what to run on click or activation.
 */
export const expandableProps = (expanded: boolean, toggle: () => void) => ({
    role: 'button',
    tabIndex: 0,
    'aria-expanded': expanded,
    onClick: toggle,
    onKeyDown: (event: React.KeyboardEvent) => {
        if (BUTTON_ACTIVATION_KEYS.includes(event.key)) {
            // Space would scroll the modal body instead of activating.
            event.preventDefault();
            toggle();
        }
    },
});
